export const PLATFORM_APP_NAME = 'Vuey Studio';
export const PLATFORM_SHORT_NAME = 'Vuey';
export const PLATFORM_DESCRIPTION = 'Calmer client delivery for projects, approvals, messages, and billing.';

export const PLATFORM_PRIMARY_COLOR = '#6969B3';
export const PLATFORM_ACCENT_COLOR = '#FF8966';
export const PLATFORM_DARK_BACKGROUND = '#2A2B2A';
export const PLATFORM_LIGHT_BACKGROUND = '#FAFAF8';
export const PLATFORM_MUTED_UI = '#706C61';

export const PLATFORM_APP_ICON_PATH = '/brand/appicon.png';
export const PLATFORM_FAVICON_PATH = '/brand/favicon.png';
export const PLATFORM_LOGO_LIGHT_PATH = '/brand/logo-light.png';
export const PLATFORM_LOGO_DARK_PATH = '/brand/logo-dark.png';
